import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import PropTypes from 'prop-types';

McpCatalogSelectField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
    })).isRequired
};

function McpCatalogSelectField({ name, label, required, options }) {
    const { control, errors, trigger } = useFormContext();

    let isError = false;
    let errorMessage = '';
    if (errors && errors.hasOwnProperty(name)) {
        isError = true;
        errorMessage = errors[name].message;
    }

    const handleBlur = () => {
        trigger(name);
    };

    return (
        <div className="form-addTicket">
            <label className="form-addTicket-label">
                {label}
                {required && <span className="required">*</span>}
            </label>
            <div className="form-addTicket-input">
                <Controller
                    name={name}
                    control={control}
                    render={({ value, onChange }) => (
                        <Autocomplete
                            options={options}
                            getOptionLabel={option => option.label || ''}
                            value={options.find(opt => opt.id === value) || null}
                            getOptionSelected={(option, selectedValue) =>
                                option.id === selectedValue?.id
                            }
                            disableClearable
                            onBlur={handleBlur}
                            onChange={(e, newValue) => {
                                onChange(newValue ? newValue.id : '');
                            }}
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    className="form-control-input form-control-wrapInput form-control-hg40"
                                    error={isError}
                                    helperText={errorMessage}
                                />
                            )}
                            renderOption={option => option.label}
                            ListboxProps={{
                                style: { maxHeight: 200, overflow: 'auto' }
                            }}
                        />
                    )}
                />
            </div>
        </div>
    );
}

McpCatalogSelectField.defaultProps = {
    required: false
};

export default McpCatalogSelectField;
